// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.admin.vendorsandpartners.framesdata.FramesDataSubscriptionResponse */
/* istanbul ignore next */
@GandalfModel
export class FramesDataSubscriptionResponse extends GandalfModelBase {

	@GandalfProperty({ designType: String })
	billingPostalCode!: string | null;

	@GandalfProperty({ designType: Date })
	framesDataExpireDate!: Date | null;

	@GandalfProperty({ designType: String })
	framesDataRenewalMessage!: string | null;

	@GandalfProperty({ designType: String })
	framesDataRenewalUrl!: string | null;

	@GandalfProperty({ designType: String })
	framesDataResponseMessage!: string | null;

	@GandalfProperty({ designType: Number })
	id!: number | null;

	@GandalfProperty({ designType: Number })
	internalContactEmployeeId!: number | null;

	@GandalfProperty({ designType: Number })
	numberOfLocations!: number | null;

	@GandalfProperty({ designType: String })
	shippingPostalCode!: string | null;

	@GandalfConstantDecorator(constants.FramesDataSubscriptionStatus)
	@GandalfProperty({ designType: constants.FramesDataSubscriptionStatus })
	status!: constants.FramesDataSubscriptionStatus | null;

	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	updatedOn!: Date | null;

	@GandalfProperty({ designType: String })
	username!: string | null;

	@GandalfProperty({ designType: Number })
	version!: number | null;

}
